const staffCommission= () =>
  import('@/views/main/staff/commission/commission.vue')
export default {
  path: '/main/staff/staffCommission',
  name: 'staffCommission',
  component: staffCommission,
  children: []
}
